import React, { useEffect,useState } from 'react';
import { Form, Input, Select, Checkbox } from 'antd';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { JOB_TYPE, JOB_TYPE_OPTIONS, SHIFT_OPTIONS, TASK_TYPE_OPTIONS } from '../../../../data/constant';
import { UseFetchListEnum } from '../../../../hooks/useFetchEnums';
import { ENUM_TYPE } from '../../../../data/constant';

function FormEmployee({ formRef, onFinish, initialValues = {}, hideAccountFields = false }) {
  const { mutateAsync: listEnum } = UseFetchListEnum();
  const [loading, setLoading] = useState(false);
  const [ jobTypeOptions, setJobTypeOptions] = useState([]);
  const [ shiftOptions, setShiftOptions] = useState([]);

  useEffect(() => {
    getEnum();
  },[]);

  const getEnum = async () => {
    try {
      setLoading(true);
      const result = await listEnum({
        enumType: [ENUM_TYPE.job_type, ENUM_TYPE.shift],
      });
      setLoading(false);
      // enums.value เป็น INT แต่ UserCompanies.JobType/Shift เป็น varchar
      // antd Select จับคู่ค่า '2' (จาก DB) กับ option 2 (number) ไม่ได้ → โชว์เลขดิบแทน label
      // แปลงเป็น string ให้ตรงกับชนิดที่ DB เก็บจริง แล้วค่าที่ submit ก็เป็น string เหมือนกัน
      const toStr = (list) => list.map((o) => ({ ...o, value: String(o.value) }));
      const jobTypeOptions = toStr(result.filter((item) => item.type === ENUM_TYPE.job_type));
      const shiftOptions = toStr(result.filter((item) => item.type === ENUM_TYPE.shift));
      setJobTypeOptions(jobTypeOptions);
      setShiftOptions(shiftOptions);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  }

  return (
    <Form name="Form" ref={formRef} layout="vertical" onFinish={onFinish} initialValues={initialValues} loading={loading}>
      <div className='mt-5 grid lg:gap-x-5 lg:grid-cols-1 '>

        {/* เพิ่มบัญชีเดิมเข้าบริษัท: ใช้ชื่อ/รหัสเดิม จึงไม่ต้องกรอกซ้ำ */}
        <Form.Item hidden={hideAccountFields} className='block mb-2 text-sm font-medium text-gray-700' name="UserName" label="ชื่อผู้ใช้" rules={[{ required: !hideAccountFields, message: 'กรุณาระบุชื่อผู้ใช้' }]}>
          <Input
            className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none"
            placeholder="ชื่อผู้ใช้"
          />
        </Form.Item>

        <Form.Item hidden={hideAccountFields} className='block mb-2 text-sm font-medium text-gray-700' name="password" label="รหัสผ่าน" rules={[{ required: false, message: 'กรุณาระบุรหัสผ่าน' }]}>
          <Input.Password
            className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none"
            placeholder="รหัสผ่าน"
            iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
          />
        </Form.Item>

        <Form.Item className='block mb-2 text-sm font-medium text-gray-700' name="JobType" label="Job Type" rules={[{ required: true, message: 'กรุณาระบุตำเเหน่ง' }]}>
          <Select
            //defaultValue=""
            style={{ width: '100%' }}
            options={jobTypeOptions}
          />
        </Form.Item>

        <Form.Item noStyle shouldUpdate={(prevValues, currentValues) => prevValues.JobType !== currentValues.JobType}>
          {({ getFieldValue, setFieldsValue }) => {
            const jobType = getFieldValue('JobType');
            // เทียบเป็น string เสมอ — ค่าจาก dropdown เป็น string ส่วน JOB_TYPE เป็น number
            // เดิมใช้ === ตรง ๆ ทำให้ตอนกดแก้ไข (ค่ามาจาก DB เป็น varchar) ช่อง "หน้าที่หลัก" ไม่โผล่
            if (String(jobType) === String(JOB_TYPE.panel_output)) {
              return <Form.Item
                className='block mb-2 text-sm font-medium text-gray-700'
                name="mainTaskType"
                label="หน้าที่หลัก"
              >
                <Select
                  allowClear
                  placeholder="เลือกหน้าที่หลัก"
                  style={{ width: '100%' }}
                  options={TASK_TYPE_OPTIONS}
                />
              </Form.Item>
            } else {
              setFieldsValue({
                mainTaskType: null,
              });
            }
          }}
        </Form.Item>

        <Form.Item className='block mb-2 text-sm font-medium text-gray-700' name="Shift" label="Shift" rules={[{ required: true, message: 'กรุณาระบุกะการทำงาน' }]}>
          <Select
            defaultValue=""
            style={{ width: '100%' }}
            options={shiftOptions}
          />
        </Form.Item>
        <Form.Item name="enable" valuePropName="checked" >
          <Checkbox >
            enable
          </Checkbox>
        </Form.Item>

        
      </div>
    </Form>
  );
}

export default FormEmployee;
